import React from 'react';
import { Timeline, Event } from 'react-timeline-scribble';
import 'react-vertical-timeline-component/style.min.css';
import ImgLogo from '../../static/images/logo.png';
import '../css/about.scss';

const About = () => (
  <div className="aboutContainer" style={{ margin: '3rem auto', maxWidth: 600 }}>
    <img src={ImgLogo} alt="Logo" className="imgLogo" />
    <div className="aboutHeader">Muhamed Brifkani</div>
    <div className="headerLabel">Introduction</div>
    <div className="aboutSubItem">
      I am a software engineer currently living in the awesome city of Nashville and have lived here most of my life.
      You can often find me spending time with the family, enjoying free time building things on the side, or just
      grabbing some coffee at a nearby cafe. My passion is to build products and tools that find meaning in peoples day
      to day lives. I currently work at Asurion where I am a Tech Lead in one of their emerging platforms to help
      customers with their devices.
    </div>
    <div className="headerLabel">Skills</div>
    <div className="aboutSubItem">
      Throughout my experience as an engineer, I've helped solve problems and built products using many modern
      technologies. These include React, React Native, Serverless, NodeJs, Typescript, Dart, AngularDart, and more. I
      have a special fond especially for how sites and apps look, which has allowed me to have a keen eye on making
      things look great. I enjoy learning new things and embrace it as part of my career each day.
    </div>
    <div className="headerLabel">Portfolio Map</div>
    <div className="aboutSubItem" />
    <Timeline className="timelineContainer">
      <Event interval="2015 - Present" title="Asurion" subtitle="Software Engineer Lead | Nashville TN">
        Leading a development team effort to help build tools and solutions for Asurions tech support platform.
      </Event>
      <Event interval="2017" title="ZamZam Management" subtitle="Software Engineer | Contractor">
        Contracted to build and manage{' '}
        <a target="_blank" rel="noopener noreferrer" href="https://zamzammanagement.com" style={{ color: '#242450' }}>
          ZamZam
        </a>{' '}
        for property management company
      </Event>
      <Event interval="2012 - 2015" title="Asurion" subtitle="Software Quality Assurance">
        Helped lead a team to write and run manual/automated tests for support solutions for Asurions tech support and
        claims platforms.
      </Event>
      <Event interval="2012" title="Middle Tennessee State University" subtitle="BS - Computer Information Systems">
        Graduate with degree of BS - Computer Information Systems
      </Event>
    </Timeline>
  </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/pages/about.js